import { render } from "./press-list.vue?vue&type=template&id=ea73e438"
import script from "./press-list.vue?vue&type=script&setup=true&lang=js"
export * from "./press-list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/in-the-press/press-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea73e438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea73e438', __exports__)) {
    api.reload('ea73e438', __exports__)
  }
  
  module.hot.accept("./press-list.vue?vue&type=template&id=ea73e438", () => {
    api.rerender('ea73e438', render)
  })

}


export default __exports__